module.exports = __webpack_public_path__ + "static/media/bootstrap.d95b9cc5.svg";